import React, { Component } from 'react';
import { ParametersSailingProvider, AlertsManagerContainer } from 'cclr-booked';
import { Spinner } from 'cclr-huge-ui';
import { Error } from '../todoPlanner/error';

/* eslint-disable */
class AlertsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { sailDate: "", shipCode: "" }
  }

  componentDidMount() {
    if ($('#sailDate').length > 0) {
      const currentSailDate = $('#sailDate')[0].value;
      const currentShipCode = $('#shipCode')[0].value;
      this.setState({
        sailDate: currentSailDate,
        shipCode: currentShipCode
      })
    }
  }

  render() {
    if (this.state.sailDate && this.state.shipCode) {
      return (
        <ParametersSailingProvider
          sailDate={this.state.sailDate}
          shipCode={this.state.shipCode}
          renderLoading={() => <Spinner />}
          renderError={() => <Error />}
        >
          {(sailing, sailings) => {
            return (
              <div>
                <AlertsManagerContainer
                  shipCode={sailing.itinerary.shipCode}
                  sailDate={sailing.itinerary.sailDate}
                />
              </div>
            );
          }}
        </ParametersSailingProvider>
      );
    } else {
      return null
    }
  }
}

export default AlertsContainer;


// WEBPACK FOOTER //
// ./reactComponents/components/alertsContainer/AlertsContainer.jsx